document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#PrimaryNav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('open', !open);
  });
  const featured = document.querySelector('[data-product-featured]');
  document.querySelectorAll('[data-thumb]').forEach((button) => button.addEventListener('click', () => {
    if (featured) featured.src = button.dataset.thumb;
  }));
});
